import { Component, Input, OnInit } from '@angular/core';
import { CandidateService } from 'src/app/_services/candidate.service';
import * as moment from 'moment';

@Component({
  selector: 'app-activity-tab',
  templateUrl: './activity-tab.component.html',
  styleUrls: ['./activity-tab.component.scss']
})
export class ActivityTabComponent implements OnInit {

  activityPage: any = 1
  activitySort: any = 'recent'
  activityType: any = 'all'
  candidateActivities: any;
  @Input() candidateid: any;

  constructor(public candidateservice: CandidateService) { }

  ngOnInit(): void {
    this.getCandidateActivity();
  }

  /**
   * Get candidate activity based on candidatenumber, page, sort type and activity type
   */
  getCandidateActivity() {
    let data = {
      candidatenumber: this.candidateid,
      page: this.activityPage,
      sort: this.activitySort,
      type: this.activityType,
    }
    this.candidateservice.getCandidateActivity(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.candidateActivities = res.message
      } else {
        this.candidateActivities = [];
      }
    })
  }

  /**
   * Get activity based selected activity type
   * @param type 
   */
  setActivityType(type: string) {
    this.activityType = type
    this.getCandidateActivity();
  }

  /**
   * Sort activity based on sorting type
   * @param sort 
   */
  sortActivity(sort: string) {
    this.activitySort = sort
    this.getCandidateActivity();
  }

  getActivityText(activity): string {
    let action;
    if (activity.oldvalue == "" || activity.oldvalue == "null") {
      activity.oldvalue = null
    }
    if (activity.newvalue === '' || activity.newvalue === null || activity.newvalue === '') {
      action = 'deleted';
    } else if (activity.oldvalue === '' || activity.oldvalue === null) {
      action = 'added';
    }
    if (activity.action === 'create' || activity.action === 'add') {
      action = 'created';
    } else if (activity.action === 'remove') {
      action = 'deleted';
    } else if (activity.action === 'update' || activity.action === 'updated') {
      action = 'updated';
    } else {
      action = activity.action;
    }
    ///For call Log and Notes
    if (action === 'updated' && activity.type === 'calllog') {
      let oldvalue = JSON.parse(activity.oldvalue.replaceAll('\n', ''))
      let newvalue = JSON.parse(activity.newvalue.replaceAll('\n', ''))
      if (oldvalue && newvalue) {
        return `Call Log are updated from (Outcome : ${oldvalue.Outcome} & Note : ${oldvalue.Note} ) to <br/>
        (Outcome : ${newvalue.Outcome} & Note : ${newvalue.Note} )`;
      }
    }
    else if (action === 'created' && activity.type === 'calllog') {
      try {
        let newvalue = JSON.parse(activity.newvalue)
        if (newvalue) {
          return `Outcome : ${newvalue.Outcome} & Note : ${newvalue.Note} `;
        }
      } catch {

      }
    }
    else if (action === 'updated' && activity.type === 'note') {

      const result = `${activity.oldvalue} ${activity.newvalue}`;
      const regex = /<p>(.*?)<\/p>/g;
      const pTagValues = [];
      let match;
      while ((match = regex.exec(result)) !== null) {
        const textContent = match[1].replace(/<[^>]*>?/gm, '');
        pTagValues.push(textContent);
      }
      const oldV = pTagValues[0];
      const newV = pTagValues[1];
      
      return `Notes are updated from ${oldV} to ${newV}`;
    }
    else if (action === 'created' && activity.type === 'note') {
      return `${activity.newvalue}`;
    }
    ///For Experience 
    else if (action === 'updated' && activity.type === 'experience' && activity.newvalue !== null) {
      if (activity.newvalue === 'null' && activity.updatedfieldname === 'enddate') {
        return `End Date has Removed`;
      } else if (activity.updatedfieldname === 'iscurrent') {
        return `Current Experience has Updated`;
      } else if (activity.newvalue !== 'null' && activity.updatedfieldname === 'enddate') {
        return `Experience End Date has been updated as ${moment(activity.newvalue).format('YYYY')}`;
      } else if (activity.updatedfieldname === 'iscurrent') {
        return `Current Experience has Updated`;
      } else if (activity.newvalue === '' && activity.updatedfieldname === 'workdescription') {
        return `Experience Work Description has been removed`;
      } else if (activity.oldvalue === 'null' && activity.updatedfieldname === 'workdescription') {
        return `Experience Work Description is updated to ${activity.newvalue}`;
      } else {
        return `Experience ${activity.updatedfieldname} is updated from ${activity.oldvalue} to ${activity.newvalue}`;
      }
    } else if (action === 'deleted' && activity.type === 'experience') {
      return `Experience has been removed`;
    }
    else if (action === 'created' && activity.type === 'experience') {
      return `Experience Added`;
    }
    //for Education
    else if (action === 'updated' && activity.type === 'education') {
      if (activity.updatedfieldname === 'enddate' || activity.updatedfieldname === 'startdate') {
        return `Education ${activity.updatedfieldname} has been updated from ${moment(activity.oldvalue).format('YYYY')} to ${moment(activity.newvalue).format('YYYY')}`;
      } else {
        return `Education ${activity.updatedfieldname} is updated from ${activity.oldvalue} to ${activity.newvalue}`;
      }
    }
    else if (action === 'deleted' && activity.type === 'education') {
      return `Education has been removed`;
    }
    else if (action === 'created' && activity.type === 'education') {
      return `Education Added`;
    }
    //for Basic Details
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue != null) {
      return `${activity.updatedfieldname} has been updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue == null) {
      return `${activity.updatedfieldname} has been updated to ${activity.newvalue}`;
    }
    //for Skills
    else if (action == 'updated' && activity.type === 'skills') {
      return `${activity.updatedfieldname} has been updated from ${activity.oldvalue} to ${activity.newvalue}`;
    } else if (action == 'created' && activity.type === 'skills') {
      return `Skills are Added`;
    }
    //for Grabbed
    else if (action == 'created' && (activity.type === 'grabbed' || activity.type == 'bulk grabbed')) {
      return `Candidate has been grabbed`;
    }
    else if (action == 'created' && activity.type === 'added') {
      return `Candidate has been Added`;
    }

    else if (action == 'created' && activity.type === 'Reveal Contact') {
      return activity.updatedfieldname;
    }

    // for tags
    else if (action === 'updated' && activity.type === 'tags') {
      return `Tag was removed`;
    }
    else if (action === 'created' && activity.type === 'tags') {
      return `Tag was added`;
    }
    else if (action === 'deleted' && activity.type === 'tags') {
      return `Tag has been removed`;
    }

    //for TalentPipeline Status
    else if (action == 'updated' && (activity.type === 'pipeline status' || activity.type === 'cron - pipeline status')) {
      return `Pipeline Status was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    //for Contact Details
    else if (action == 'created' && activity.type === 'contact details - social profile') {
      return `New Social Profile Link was Added -  ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - email') {
      if(activity?.contactdetailcategory){
        //In case of maually-added contacts only
        let primaryMarkText = (activity?.enrichedvia === 'added-manually' && activity?.isprimary == 1) ? 'and marked as primary ' : '';

        if(activity.contactdetailcategory === 'personal'){
          return `Personal email added ${primaryMarkText}- ${activity.newvalue}`;
        }
        else{
          return `Professional email added ${primaryMarkText}- ${activity.newvalue}`;
        }
      }
      return `New Email ID was Added -  ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'contact details - email') {
      if(activity.updatedfieldname === 'isprimary'){
        if(activity.newvalue === "1"){
          return `Email marked as primary: ${activity.contactdetail}`;
        }
        if(activity.newvalue === "0"){
          return `Email unmarked as primary: ${activity.contactdetail}`;
        }
      }
      return `Email ID was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - email') {
      return `Email ID was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - contact number') {
      let primaryMarkText = (activity?.enrichedvia === 'added-manually' && activity?.isprimary == 1) ? 'and marked as primary ' : '';
      return `New Contact Number was Added ${primaryMarkText}-  ${activity.newvalue}`;
    }
    else if (action == 'updated' && activity.type === 'contact details - contact number') {
      if(activity.updatedfieldname === 'isprimary'){
        if(activity.newvalue === "1"){
          return `Contact number marked as primary: ${activity.contactdetail}`;
        }
        if(activity.newvalue === "0"){
          return `Contact number unmarked as primary: ${activity.contactdetail}`;
        }
      }
      return `Contact Number was updated from ${activity.oldvalue} to ${activity.newvalue}`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - contact number') {
      return `Contact Number was removed`;
    }
    else if (action == 'delete' && activity.type === 'note') {
      return `Note was removed`;
    }
    else if (activity.updatedfieldname == 'primaryemailid' || activity.updatedfieldname == 'primarycontactnumber') {
      return `Primary ${activity.type} has Added -  ${activity.newvalue}`;
    } else if (activity.action == 'pipl premium enrichment') {
      return 'Premium enrichment was done'
    } else if (activity.tablename) {
      if (activity.action == 'added') {
        return `Cv was added (${activity.oldvalue})`
      } else if (activity.action == 'removed') {
        return `Cv was removed (${activity.oldvalue})`
      }
    }
    if (activity.action == 'details updated') {
      return activity.oldvalue
    }
  }

}
